module.exports = __webpack_public_path__ + "static/img/4.0593105.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/4.png
// module id = +Ich
// module chunks = 0